(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('Geolocalization', Geolocalization);

    Geolocalization.$inject = ['$timeout'];

    var markers = [];

    function Geolocalization($timeout) {

        var map,
            latlng,
            geocoder,
            myOption,
            addressInput,
            marker;

        var service = {
            initializeGoogleMap: initializeGoogleMaps,
            geocodeFromAddress: geocodeFromAddress,
            reverseGeocode: reverseGeocode,
            addMarkerFromAddress: addMarkerFromAddress,
            clearMarkers: clearMarkers
        };


        return service;

        function initializeGoogleMaps(tabObjects, scope) {
            latlng = new google.maps.LatLng(45.4675, 9.18560);
            geocoder = new google.maps.Geocoder();
            myOption = {
                zoom: 15,
                center: latlng,
                mapTypeId: google.maps.MapTypeId.ROADMAP

            };
            map = new google.maps.Map(document.getElementById("map_canvas"), myOption);
            // google.maps.event.addListener(map, "click", function (event) {
            //     if (!marker)
            //         marker = new google.maps.Marker({
            //             map: map,
            //             position: latlng,
            //             draggable: true,
            //             title: document.getElementById("field_objectName").value
            //         });
            //     else
            //         marker.setPosition(event.latLng);
            //     getAddressFromMarkerPosition(marker, tabObjects, scope);
            // });

            google.maps.event.addListener(map, "click", function (evt) {
                if (markers.length > 0) {
                    markers[0].setPosition(evt.latLng);
                    addMarkerFromAddress(evt.latLng, tabObjects, scope);
                } else {
                    addMarkerFromAddress(evt.latLng, tabObjects, scope);
                }
            });
            reverseGeocode(tabObjects, scope);

        }

        function geocodeFromAddress(tabObjects, scope) {
            addressInput = (tabObjects.objectLocation);
            if (addressInput != null || addressInput != "") {
                geocoder.geocode({'address': addressInput}, function (result, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        var latlng = result[0].geometry.location;
                        tabObjects.objectLatitude = latlng.lat();
                        tabObjects.objectLongitude = latlng.lng();
                        addMarkerFromAddress(latlng, tabObjects, scope);
                    }
                });
            }

        }

        function reverseGeocode(tabObjects, scope) {
            var lat = tabObjects.objectLatitude;
            var lng = tabObjects.objectLongitude;

            if(lat === null && lng === null){
                lat = tabObjects.fieldLatitude;
                lng = tabObjects.fieldLongitude;
            }

            if (angular.isDefined(lat) && angular.isDefined(lng)) {
                var latlng = new google.maps.LatLng(lat, lng);
                geocoder.geocode({"latLng": latlng}, function (result, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        if (result[0]) {
                            tabObjects.objectLocation = (result[0].formatted_address);
                            addMarkerFromAddress(latlng, tabObjects, scope);
                        }
                    }
                });
            } else {
                geocodeFromAddress(tabObjects);
            }
        }

        function addMarkerFromAddress(latlng, tabObjects, scope) {
            clearMarkers();

            map.setCenter(latlng);
            marker = new google.maps.Marker({
                map: map,
                position: latlng,
                draggable: true,
                title: document.getElementById("field_objectName").value
            });

            var infoWindow = new google.maps.InfoWindow();
            google.maps.event.addListener(marker, "click", function (evt) {
                infoWindow.setContent(this.get("title"));
                infoWindow.open(map, this);
            });


            //marker listener for dragend event in the map
            marker.addListener("dragend", function (event) {
                getAddressFromMarkerPosition(marker, tabObjects, scope);
            });
            getAddressFromMarkerPosition(marker, tabObjects, scope);
            markers.push(marker);
        }

        function getAddressFromMarkerPosition(marker, tabObjects, scope) {
            tabObjects.objectLatitude = marker.position.lat();
            tabObjects.objectLongitude = marker.position.lng();

            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

            geocoder.geocode({"latLng": latlng}, function (result, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    if (result[0]) {
                        tabObjects.objectLocation = (result[0].formatted_address);
                    }
                }
            });
            if (!scope.$$phase) scope.$apply();
        }

        function clearMarkers() {
            for (var i = markers.length - 1; i >= 0; i--) {
                markers[i].setMap(null);
                markers.splice(i, 1);
            }
        }
    }
})();
